export enum COMPANY_TYPE {
  COMPANY = "company",
  MEDIA_CENTER = "media_center",
  AD_SALES_AGENCY = "ad_sales_agency",
  BROADCASTER = "broadcaster",
  TV_KIDS_AD_SALES_AGENCY = "tv_kids_ad_sales_agency",
  TV_KIDS_BROADCASTER = "tv_kids_broadcaster",
  TV_AD_SALES_AGENCY = "tv_ad_sales_agency",
  TV_BROADCASTER = "tv_kids_broadcaster",
}
